export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-picker/index.js